module.exports = __webpack_public_path__ + "static/team-1-4-b0971d4e27a2f21c701c5e79dc953050.jpg";